import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {AgendaCalendarModel} from '../../../api/entity/agendaCalendar.model';
import {AgendaCalendarConverter} from '../../../api/converter/agendaCalendar.converter';


@Injectable({providedIn: 'root'})
export class AgendaCalendarDataService extends AbstractDataServiceV2<AgendaCalendarModel, AgendaCalendarConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: AgendaCalendarConverter) {
        super('AgendaCalendar', http, httpUrlGenerator, logger, config, converter);
    }
}
